import { ToggleButton } from "../index";
import { useState } from "react";
import EmailPhoneCard from "./someone-new/email-phone-card/EmailPhoneCard";
import DomesticTransfer from "./someone-new/domestic-transfer/DomesticTransfer";
import BillPayment from "./someone-new/bill-payment/BillPayment";
import InternationalFundTransfer from "./someone-new/internationalfund-transfer/InternationalFundTransfer";
const SomeoneNew = ({
  sourceAccountId,
  sourceAccount,
  initialTab = "Email/Phone/Card",
}) => {
  const [tab, setTab] = useState(initialTab);

  const renderTab = () => {
    switch (tab) {
      case "Email/Phone/Card":
        return (
          <EmailPhoneCard
            sourceAccountId={sourceAccountId}
            sourceAccount={sourceAccount}
          />
        );
      case "Domestic Transfer":
        return (
          <DomesticTransfer
            sourceAccountId={sourceAccountId}
            sourceAccount={sourceAccount}
          />
        );
      case "Bill Payment":
        return (
          <BillPayment
            sourceAccountId={sourceAccountId}
            sourceAccount={sourceAccount}
          />
        );
      case "International Transfer":
        return (
          <InternationalFundTransfer
            sourceAccountId={sourceAccountId}
            sourceAccount={sourceAccount}
          />
        );
      default:
        return (
          <EmailPhoneCard
            sourceAccountId={sourceAccountId}
            sourceAccount={sourceAccount}
          />
        );
    }
  };

  return (
    <div className="new-transfer-card row p-3 border justify-content-between rounded-3 mt-4 mx-0">
      <div className="d-flex align-items-center justify-content-center">
        <div className="someone-new-toggle-options-width-control ">
          <ToggleButton
            options={[
              "Email/Phone/Card",
              "Domestic Transfer",
              "Bill Payment",
              "International Transfer",
            ]}
            defaultValue={tab}
            onChange={(value) => setTab(value)}
            block={true}
          />
        </div>
      </div>

      {renderTab()}
    </div>
  );
};

export default SomeoneNew;
